// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1ZptK","icon":"SortAdornment_icon__2BlWX","up":"SortAdornment_up__2IuSq","down":"SortAdornment_down__3bcFF","active":"SortAdornment_active__2NKZv"};